import { FORM_TYPE } from "@/enums/apps.enum";
import { ExchangeInterface } from "@/interface/business/exchange.interface";
import { ExchangeType } from "@/types/business/exchange.type";

export class Exchange implements ExchangeInterface {
  id: string = "";
  currency_id: string = "";
  currency: string = "";
  exchange: number = 0;
  inverse: number = 0;
  formType: string = FORM_TYPE.CREATE;

  constructor(data: ExchangeType) {
    if (data) {
      this.id = data.id || "";
      this.currency_id = data.currency_id || "";
      this.currency = data.currency || "";
      this.exchange = data.exchange || 0;
      this.inverse = data.inverse || 0;
    }
  }

  setFormEdit(): void {
    this.formType = FORM_TYPE.EDIT;
  }
}
